import { Pipe, PipeTransform } from '@angular/core';

import { extractLanguageCode } from '@shared/utils/locale';

@Pipe({
  name: 'localeKey',
})
export class LocaleKeyPipe implements PipeTransform {
  transform(locale: string, suffix = ''): string {
    return 'WEB_LOCALE_' + extractLanguageCode(locale).toUpperCase() + suffix;
  }
}
